import React from 'react'
import Header from './Header'

const About = () => {
  return (
    <div>
      <Header/>
    </div>
  )
}

export default About
